import React from 'react';
import PropTypes from 'prop-types';

import ResearchReport from '../ResearchReport/index.jsx';


class TaxonomyTermsList extends React.Component {
  render() {
    var result = null;

    if (this.props.articles.length) {
      var innerContent = [];
      for (var i = 0; i < this.props.articles.length; i++) {
        var article = this.props.articles[i];

        innerContent.push(
          <div key={article.id} className="cs-research-report-articles__item">
            <ResearchReport article={article} />
          </div>
        );
      }

      result = (
        <div className="cs-research-report-articles">
          {innerContent}
        </div>
      );
    }


    return result;
  }
}


TaxonomyTermsList.propTypes = {
  articles: PropTypes.array
};

TaxonomyTermsList.defaultProps = {
  articles: []
};


export default TaxonomyTermsList;

